module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_j_normal.8536832c.png";